function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { DEFAULT_VIDEO_FORMAT, VideoColourSpace, VideoFormat } from '../../core/player/video-format';
import { AudioFormat } from '../../core/player/audio-format';
import { isEdgeDesktop, isEdgeOnWindows, isSafariDesktop, isSafariMobile, isWindows } from '../../utils/device-type';
import { getHDCPstatusForUHD, probeSupportedAudioCodecs, getMediaSourceSupportedAudioFormats, isAudioCodecSupported, isVideoCodecSupported, probeHdrSupportByMediaCapabilities, getHDCPStatusForHD } from '../../utils/probe-utils';
import { UhdHdrCodec, AudioCodecType, DrmKind } from '../../utils/probe-utils.enums';
function getMaxFrameRate() {
    return Infinity;
}
function getMaxVideoFormat(_) {
    return _getMaxVideoFormat.apply(this, arguments);
}
function _getMaxVideoFormat() {
    _getMaxVideoFormat = _async_to_generator(function(param) {
        var deviceInfo, deviceType, codec, is4KSupported;
        return _ts_generator(this, function(_state) {
            deviceInfo = param.deviceInfo, deviceType = param.type;
            codec = UhdHdrCodec.Uhd;
            is4KSupported = isVideoCodecSupported(codec);
            if (is4KSupported) {
                return [
                    2,
                    VideoFormat.UHD
                ];
            }
            return [
                2,
                DEFAULT_VIDEO_FORMAT
            ];
        });
    });
    return _getMaxVideoFormat.apply(this, arguments);
}
function getSupportedColourSpaces(_) {
    return _getSupportedColourSpaces.apply(this, arguments);
}
function _getSupportedColourSpaces() {
    _getSupportedColourSpaces = _async_to_generator(function(param) {
        var deviceInfo, deviceType, codec, colourSpaces, isHdr10Supported, isUHDhdrSupported, drmKind, hdcpSupport, isDolbyVisionSupported;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    deviceInfo = param.deviceInfo, deviceType = param.type;
                    codec = UhdHdrCodec.Hdr10;
                    colourSpaces = [
                        VideoColourSpace.SDR
                    ];
                    isHdr10Supported = false;
                    isUHDhdrSupported = isVideoCodecSupported(codec);
                    if (!isUHDhdrSupported) return [
                        3,
                        5
                    ];
                    if (!// For browsers, mediaCapabilities.decodingInfo() only works reliably for Safari so far
                    isSafariDesktop(deviceInfo, deviceType)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        probeHdrSupportByMediaCapabilities()
                    ];
                case 1:
                    isHdr10Supported = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    drmKind = deviceType === DeviceType.Ion ? DrmKind.PlayReady : DrmKind.Widevine;
                    return [
                        4,
                        getHDCPstatusForUHD(codec, drmKind)
                    ];
                case 3:
                    hdcpSupport = _state.sent();
                    if (hdcpSupport.isSupported) {
                        // probe support for codec + HDR electro-optical transfer function (EOTF)
                        isHdr10Supported = isVideoCodecSupported(codec, true);
                    }
                    _state.label = 4;
                case 4:
                    if (isHdr10Supported) {
                        colourSpaces.push(VideoColourSpace.HDR10);
                    }
                    _state.label = 5;
                case 5:
                    isDolbyVisionSupported = isVideoCodecSupported(UhdHdrCodec.DolbyVision);
                    if (isDolbyVisionSupported) {
                        colourSpaces.push(VideoColourSpace.DV);
                    }
                    return [
                        2,
                        colourSpaces
                    ];
            }
        });
    });
    return _getSupportedColourSpaces.apply(this, arguments);
}
function getSupportedAudioFormats(param) {
    var deviceInfo = param.deviceInfo, deviceType = param.type;
    // ION will be using the browser mse-capabilities for the time being, JIRA Ticket Created
    // https://gspcloud.atlassian.net/browse/VPTJS-12138
    if (deviceType === DeviceType.Ion) {
        return getMediaSourceSupportedAudioFormats();
    }
    var audioFormats = [
        AudioFormat.STEREO
    ];
    var codec = UhdHdrCodec.Hdr10;
    var osName = deviceInfo.operatingSystemName;
    var isUHDhdrSupported = isVideoCodecSupported(codec);
    if (isUHDhdrSupported) {
        // For browsers, only Safari and Edge support ac-3, ec-3/Atmos so far
        // https://developer.dolby.com/platforms/html5/browser-support/
        // https://developer.dolby.com/platforms/apple/macos/os-support/
        if (isSafariDesktop(deviceInfo, deviceType) || isWindows(osName) && isEdgeDesktop(deviceInfo, deviceType)) {
            if (isAudioCodecSupported(AudioCodecType.DolbyDigital)) {
                audioFormats.push(AudioFormat.SURROUND_5_1);
            }
            if (isAudioCodecSupported(AudioCodecType.DolbyDigitalPlus)) {
                audioFormats.push(AudioFormat.SURROUND_7_1, AudioFormat.ATMOS);
            }
        }
    }
    return audioFormats;
}
function getSupportedAudioCodecs() {
    return probeSupportedAudioCodecs();
}
function getPreloadBufferTime(deviceInfo, deviceType) {
    if (isSafariDesktop(deviceInfo, deviceType)) {
        return 4;
    }
    return 3;
}
function getPreloadSupport(param) {
    var deviceInfo = param.deviceInfo, deviceType = param.type;
    return {
        preconstructItems: true,
        preloadItems: true,
        hasPrefetchSupport: true,
        preloadBufferTimeSecs: getPreloadBufferTime(deviceInfo, deviceType)
    };
}
function getCompatibleStreamPropertyGroups(device) {
    return _getCompatibleStreamPropertyGroups.apply(this, arguments);
}
function _getCompatibleStreamPropertyGroups() {
    _getCompatibleStreamPropertyGroups = _async_to_generator(function(device) {
        var _ref, maxFrameRate, maxVideoFormat, supportedColourSpaces;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            getMaxFrameRate(),
                            getMaxVideoFormat(device),
                            getSupportedColourSpaces(device)
                        ])
                    ];
                case 1:
                    _ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        3
                    ]), maxFrameRate = _ref[0], maxVideoFormat = _ref[1], supportedColourSpaces = _ref[2];
                    return [
                        2,
                        [
                            {
                                maxFrameRate: maxFrameRate,
                                maxVideoFormat: maxVideoFormat,
                                supportedColourSpaces: supportedColourSpaces
                            }
                        ]
                    ];
            }
        });
    });
    return _getCompatibleStreamPropertyGroups.apply(this, arguments);
}
function getCodecSwitchingSupport(device) {
    return !isEdgeOnWindows(device.deviceInfo, DeviceType.Browser) && !isSafariDesktop(device.deviceInfo, device.type) && !isSafariMobile(device.deviceInfo, device.type);
}
function getHdcpCompliance(drmType) {
    return _getHdcpCompliance.apply(this, arguments);
}
function _getHdcpCompliance() {
    _getHdcpCompliance = _async_to_generator(function(drmType) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                getHDCPStatusForHD(drmType)
            ];
        });
    });
    return _getHdcpCompliance.apply(this, arguments);
}
function listenToHdcpComplianceChanges(onChange, drmTypes) {
    if (!drmTypes) return false;
    if ('addEventListener' in screen) {
        // @ts-ignore
        screen.addEventListener('change', function() {
            var statusPromise = drmTypes.map(function(drmType) {
                return getHDCPStatusForHD(drmType);
            });
            Promise.all(statusPromise).then(function(statuses) {
                onChange(statuses.every(function(status) {
                    return status;
                }));
            });
        });
        return true;
    }
    return false;
}
export var mseBrowserCapabilities = {
    getCompatibleStreamPropertyGroups: getCompatibleStreamPropertyGroups,
    getSupportedAudioFormats: getSupportedAudioFormats,
    getSupportedAudioCodecs: getSupportedAudioCodecs,
    getPreloadSupport: getPreloadSupport,
    getCodecSwitchingSupport: getCodecSwitchingSupport,
    getHdcpCompliance: getHdcpCompliance,
    listenToHdcpComplianceChanges: listenToHdcpComplianceChanges
};

//# sourceMappingURL=mse-capabilities.js.map